<template>
  <div class="timeline-item flex gap-4">
    <div class="flex flex-col">
      <Avatar
        :url="avatarUrl"
        :icon="avatarIcon"
        :text="avatarText"
      />
      <div class="timeline-line flex-grow bg-quaternary w-[2px] rounded-full ml-6 my-1 h-4">&nbsp;</div>
    </div>
    <div class="text-sm">
      <div class="flex gap-2 items-center">
        <div class="text-secondary font-medium">{{ title }}</div>
        <div
          v-tippy="{ content: $dayjs(timestamp).format('LLLL') }"
          class="text-xs"
        >
          {{ $dayjs(timestamp).from($dayjs()) }}
        </div>
      </div>
      <div class="text-tertiary mb-4">
        <slot name="content"></slot>
      </div>
    </div>
  </div>
</template>

<script setup>
import Avatar from '@/components/avatar/Avatar.vue'

defineProps({
  title: {
    type: String,
    default: null
  },
  content: {
    type: String,
    default: null
  },
  avatarUrl: {
    type: String,
    default: null
  },
  avatarIcon: {
    type: String,
    default: null
  },
  avatarText: {
    type: String,
    default: null
  },
  timestamp: {
    type: String,
    default: null
  }
})
</script>

<style scoped>
.timeline-item {
  position: relative;
}
</style>
